import { render, staticRenderFns } from "./PackageCatalog.vue?vue&type=template&id=ef4d1436&scoped=true"
import script from "./PackageCatalog.vue?vue&type=script&lang=js"
export * from "./PackageCatalog.vue?vue&type=script&lang=js"
import style0 from "./PackageCatalog.vue?vue&type=style&index=0&id=ef4d1436&prod&scoped=true&lang=css"
import style1 from "./PackageCatalog.vue?vue&type=style&index=1&id=ef4d1436&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d1436",
  null
  
)

export default component.exports